import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { ArrowRight, HeartHandshake } from "lucide-react";
export default function OurClinicalVision() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section data-section-id="23588" id="the-modern-alternative" className="bg-background text-foreground relative py-24 md:py-32 lg:py-40 overflow-hidden">
      {}
      <div className="absolute inset-0 z-0 pointer-events-none">
        <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1612128/img/abstract_enamel_pattern.png" alt="Macro photography of a custom oral appliance device" className="w-full h-full object-cover opacity-10 mix-blend-overlay" />
        {}
        <div className="absolute inset-0 bg-gradient-to-b from-background via-background/80 to-background" />
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,_var(--accent)_0%,_transparent_70%)] opacity-20" />
      </div>

      <div ref={ref} className={`relative z-10 max-w-4xl mx-auto px-6 flex flex-col items-center text-center transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
        {}
        <div className="mb-8 p-3 rounded-full bg-accent/10 text-accent border border-accent/20 backdrop-blur-sm">
          <HeartHandshake className="w-8 h-8" strokeWidth={1.5} />
        </div>

        {}
        <h1 className="font-sans text-4xl md:text-6xl lg:text-7xl font-bold tracking-tight mb-10 text-primary leading-[1.1]">
          The Modern, Mask-Free <br className="hidden md:block" />
          <span className="text-accent italic">Alternative to CPAP</span>
        </h1>

        {}
        <div className="space-y-8 text-lg md:text-xl leading-relaxed text-muted-foreground font-normal max-w-3xl">
          <p>
            At Solutions for Sleep Apnea, we specialize in Oral Appliance Therapy—a 
            clinically proven, non-invasive treatment for obstructive sleep apnea. 
            This approach replaces bulky machinery with a custom-fitted device 
            that is as comfortable as it is effective.
          </p>
          <p>
            Our custom appliances work by gently supporting the jaw in an optimal 
            position to keep your airway open naturally. Because they are silent, 
            portable, and require no electricity, they offer the freedom to 
            travel and sleep without the constraints of traditional therapy.
          </p>
          <p className="font-semibold text-primary">
            Experience medical-grade precision combined with the simplicity of 
            a mouthguard, delivered with expert care.
          </p>
        </div>

        {}
        <div className="mt-14 flex flex-col sm:flex-row gap-4 w-full sm:w-auto">
          <Button asChild size="lg" className="rounded-lg bg-accent text-accent-foreground hover:bg-accent/90 text-base px-8 h-12 shadow-lg shadow-accent/20 hover:shadow-accent/30 transition-all duration-300">
            <Link to="/OralAppliancesPage">
              Learn About OAT <ArrowRight className="ml-2 w-4 h-4" />
            </Link>
          </Button>
          <Button asChild variant="outline" size="lg" className="rounded-lg text-base px-8 h-12 border-primary/20 hover:bg-primary/5 hover:text-primary hover:border-primary/40 transition-all duration-300 bg-transparent">
            <Link to="/TreatmentsPage">Compare All Options</Link>
          </Button>
        </div>
      </div>
    </section>;
}